import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { ScenarioStatus, scenarioStatusOptions } from 'src/api/types';
import { HintableOption, OptionWithHint } from 'src/components/form/Select/comps';
import { LABELS } from '../labels';

const optionsWithHints: HintableOption[] = scenarioStatusOptions.map((o) => {
  let hint = '';
  switch (o.value) {
    case ScenarioStatus.Draft:
      hint = LABELS.scenarioStatusDraft;
      break;
    case ScenarioStatus.Open:
      hint = LABELS.scenarioStatusOpen;
      break;
    case ScenarioStatus.Closed:
      hint = LABELS.scenarioStatusClosed;
      break;
  }
  return {
    ...o,
    hint,
  };
});

interface ScenarioStatusSelectProps extends Omit<Props, 'value'> {
  value: string | undefined | null;
  onChange: (value: { label: string; value: string }, meta: ActionMeta<{ label: string; value: string }>) => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
}

export const ScenarioStatusSelect: React.FC<ScenarioStatusSelectProps> = ({
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder = 'Status',
}) => {
  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(optionsWithHints, (o) => o.value === value)}
        placeholder={placeholder}
        options={optionsWithHints}
        onChange={onChange}
        components={{ Option: OptionWithHint }}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
